import config from "../../config";
import { Dealer, DealerSetupStatus } from "./types";

const SignificantBit = (status: DealerSetupStatus): number => {
  const index = Object.values(DealerSetupStatus).indexOf(status);
  // console.log("SignificantBit: " + status + " = " + index);
  return Math.pow(2, index - 1);
};

export const IsStatusSearchConsented = (
  setupStatus: number | undefined,
): boolean => {
  const res =
    ((setupStatus || 0) & SignificantBit(DealerSetupStatus.SEARCH_CONSENT)) > 0;
  // console.log("IsStatusSearchConsented = " + res);
  return res;
};

export const IsStatusPricingAgreed = (
  setupStatus: number | undefined,
): boolean => {
  const res =
    ((setupStatus || 0) & SignificantBit(DealerSetupStatus.PRICING_AGREED)) > 0;
  // console.log("IsStatusPricingAgreed = " + res);
  return res;
};

export const IsStatusComplianceApproved = (
  setupStatus: number | undefined,
): boolean => {
  const res =
    ((setupStatus || 0) &
      SignificantBit(DealerSetupStatus.COMPLIANCE_APPROVED)) >
    0;
  // console.log("IsStatusComplianceApproved = " + res);
  return res;
};

export const IsStatusDealerSigned = (
  setupStatus: number | undefined,
): boolean => {
  const res =
    ((setupStatus || 0) & SignificantBit(DealerSetupStatus.DEALER_SIGNED)) > 0;
  // console.log("IsStatusDealerSigned = " + res);
  return res;
};

export const IsStatusFullySetup = (
  setupStatus: number | undefined,
): boolean => {
  return (
    IsStatusSearchConsented(setupStatus || 0) &&
    IsStatusPricingAgreed(setupStatus || 0) &&
    IsStatusComplianceApproved(setupStatus || 0) &&
    IsStatusDealerSigned(setupStatus || 0)
  );
};

export const IsSearchConsented = (dealer: Dealer | undefined): boolean => {
  return IsStatusSearchConsented(dealer?.setupStatus || 0);
};

export const IsPricingAgreed = (dealer: Dealer | undefined): boolean => {
  return IsStatusPricingAgreed(dealer?.setupStatus || 0);
};

export const IsComplianceApproved = (dealer: Dealer | undefined): boolean => {
  return IsStatusComplianceApproved(dealer?.setupStatus || 0);
};

export const IsDealerSigned = (dealer: Dealer | undefined): boolean => {
  return IsStatusDealerSigned(dealer?.setupStatus || 0);
};

export const IsFullySetup = (dealer: Dealer | undefined): boolean => {
  return IsStatusFullySetup(dealer?.setupStatus || 0);
};

export const IsDealerApproved = (dealer: Dealer | undefined): boolean => {
  const res = (dealer?.approvedDate || "") !== "";
  // console.log("IsDealerApproved = " + res);
  return res;
};

export const NeedsSearchConsent = (dealer: Dealer | undefined): boolean => {
  return !dealer?.franchised && !IsSearchConsented(dealer);
};

export const NeedsPricingAgreed = (dealer: Dealer | undefined): boolean => {
  return /*!NeedsSearchConsent(dealer) &&*/ !IsPricingAgreed(dealer);
};

export const NeedsComplianceApproved = (
  dealer: Dealer | undefined,
): boolean => {
  return IsPricingAgreed(dealer) && !IsComplianceApproved(dealer);
};

export const NeedsDealerSigned = (dealer: Dealer | undefined): boolean => {
  // Feb 2025 - Dealer now needs to sign ASAP. No longer need to wait for compliance to be approved
  return /*IsComplianceApproved(dealer) &&*/ !IsDealerSigned(dealer);
};

export const NeedsPricingSigned = (dealer: Dealer | undefined): boolean => {
  return (
    config.PRICING_ESIGN &&
    (dealer?.ePricing || false) &&
    (dealer?.needsPricingEsign || false)
  );
};

export const NeedsDealerSignedForcably = (
  dealer: Dealer | undefined,
): boolean => {
  return dealer?.needsEsignForced || false;
};
